import React, { useEffect, useRef, useState } from 'react';
import Editor from 'src/components/Editor';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store/reducers/state';
import { useVideoLibraryActions } from 'src/store/videoLibrary/actions';
import Loader from 'src/components/loader';
import { useVideosActions } from 'src/store/videos/actions';
import { ImageStringConverter } from 'src/components/utilities/utils';

type BannerKey = 'adBanner' | 'adBanner2';

const AdBanner = () => {
  const dispatch = useDispatch();
  const videoLibraryAction = useVideoLibraryActions(dispatch);
  const videoAction = useVideosActions(dispatch);

  const [editorState, setEditorState] = useState<string>('');
  const [editorState2, setEditorState2] = useState<string>('');
  const pendingMediaFor = useRef<BannerKey | null>(null);
  const activeBanner = useRef<BannerKey | null>(null);

  const { adBanner, isAdBannerUpdateLoading, mediaUrl } = useSelector((state: RootState) => {
    return {
      adBanner: state.videoLibrary.adBanner,
      isAdBannerUpdateLoading: state.videoLibrary.isAdBannerUpdateLoading,
      mediaUrl: state.videos.mediaUrl
    };
  });

  const activate = (key: BannerKey) => {
    pendingMediaFor.current = null;
    activeBanner.current = key;
  };

  useEffect(() => {
    if (adBanner && Object.keys(adBanner).length) {
      setEditorState(adBanner.adBanner || '');
      setEditorState2(adBanner.adBanner2 || '');

      activeBanner.current = null;
      if (adBanner.adBanner) {
        pendingMediaFor.current = 'adBanner';
        videoAction.getMediaUrlRequest(adBanner.adBanner);
      } else if (adBanner.adBanner2) {
        pendingMediaFor.current = 'adBanner2';
        videoAction.getMediaUrlRequest(adBanner.adBanner2);
      } else {
        pendingMediaFor.current = null;
      }
    }
  }, [adBanner]);

  useEffect(() => {
    if (!mediaUrl) return;

    if (pendingMediaFor.current === 'adBanner') {
      setEditorState(mediaUrl);
      if (adBanner?.adBanner2) {
        pendingMediaFor.current = 'adBanner2';
        videoAction.getMediaUrlRequest(adBanner.adBanner2);
      } else {
        pendingMediaFor.current = null;
      }
      return;
    }
    if (pendingMediaFor.current === 'adBanner2') {
      setEditorState2(mediaUrl);
      pendingMediaFor.current = null;
      return;
    }

    if (activeBanner.current === 'adBanner') {
      setEditorState(mediaUrl);
    } else if (activeBanner.current === 'adBanner2') {
      setEditorState2(mediaUrl);
    }
  }, [mediaUrl]);

  const saveBanner = (path: BannerKey, value: string) => {
    const payloadData = [{ op: 'replace', path, value: ImageStringConverter(value) }];
    videoLibraryAction.updateAdBannerRequest(payloadData);
  };

  const onSubmitBanner1 = (e: React.FormEvent) => {
    e.preventDefault();
    saveBanner('adBanner', editorState);
  };

  const onSubmitBanner2 = (e: React.FormEvent) => {
    e.preventDefault();
    saveBanner('adBanner2', editorState2);
  };

  return (
    <div>
      {isAdBannerUpdateLoading && <Loader />}
      <div className="spotlight-rows">
        <form onSubmit={onSubmitBanner1}>
          <button type="submit" className="btn-primary w-auto mx-0 ml-auto mb-4 mt-0">
            Save
          </button>
          <div className="shadow p-5 mt-6 border">
            <div className="px-5">
              <div className={`form-group mb-4`}>
                <div className="mb-3">
                  <h6 className="font-bold mb-1">Home Page Ad Banner</h6>
                  <p>
                    Display a custom message on your home page horizontal ad space,that will appear
                    below your highlight reel and above your search filter.
                  </p>
                  <p>Ideal for a welcome message and/or advertising space</p>
                </div>
                <div
                  onFocusCapture={() => activate('adBanner')}
                  onMouseDownCapture={() => activate('adBanner')}>
                  <Editor editorState={editorState} setEditorState={setEditorState} />
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      {/* Ad Banner 2 */}
      <div className="spotlight-rows mt-8">
        <form onSubmit={onSubmitBanner2}>
          <button type="submit" className="btn-primary w-auto mx-0 ml-auto mb-4 mt-0">
            Save
          </button>
          <div className="shadow p-5 mt-6 border">
            <div className="px-5">
              <div className="form-group mb-4">
                <div className="mb-3">
                  <h6 className="font-bold mb-1">Home Page Ad Banner 2</h6>
                  <p>
                    Display an additional custom message on your home page that will appear below
                    your first ad banner.
                  </p>
                  <p>Ideal for a secondary message and/or advertising space</p>
                </div>
                <div
                  onFocusCapture={() => activate('adBanner2')}
                  onMouseDownCapture={() => activate('adBanner2')}>
                  <Editor editorState={editorState2} setEditorState={setEditorState2} />
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdBanner;